export default __webpack_public_path__ + "static/media/mtd-icon.22ac08d2.svg";